import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { connect } from 'react-redux';
import { reduxForm, getFormValues, Field } from 'redux-form';
import { MDBDropdown } from 'mdbreact';
import {
  getSearchedCompaniesList,
} from '../../services/companies';
import { routes } from '../../utils/constants';
import { H2 } from '../../theme/typography';
import Actions from '../../assets/icons/Actions.svg';
import ViewWhite from '../../assets/icons/ViewWhite.svg';
import EditWhite from '../../assets/icons/EditWhite.svg';
import CheckmarkCircledOrange from '../../assets/icons/CheckmarkCircledOrange.svg';
import CloseGray from '../../assets/icons/CloseGray.svg';
import { Icon as CommonIcon } from '../ReactComponent/Icon';
import { DropdownItem, DropdownItemIcon } from '../ReactComponent/SortableTable/css';
import {
  ButtonGroup,
  TitleGroup,
  FilterContainer,
  DivisionCheckboxesContainer,
  ManageCompaniesContainer,
} from './css';
import { putReduxAllCompanies } from './actions';
import { homeUrlNoTrailingSlash, runningOnBrowser } from '../../utils/func';
import NoDataDecorator from '../ReactComponent/SortableTable/NoDataDecorator';
import { MDBDropdownToggle, StyledMDBDropdownMenu } from '../_styledComponents/MDBDropdownToggle';
import CustomizeTableView from '../ReactComponent/CustomizeTableView';
import { anyOneRequiredInGroup } from '../../utils/validator';
import TextInput from '../../lib/ui/form_elements/TextInput';
import PrimaryButton from '../../lib/ui/buttons/PrimaryButton';
import SortableTableStyled from '../ReactComponent/SortableTableStyled';

const formName = 'ManageCompanies';

const Dropdown = ({ companyId, userEmail, division }) => (
  <MDBDropdown className="dropdown">
    <MDBDropdownToggle className="border-0">
      <CommonIcon iconSrc={Actions} />
    </MDBDropdownToggle>
    <StyledMDBDropdownMenu className="text-white bg-dark" basic>
      <DropdownItem onClick={() => {
        window.open(`/create-company?companyId=${companyId}&division=${division}`, '_blank');
      }}
      >
        <DropdownItemIcon iconSrc={ViewWhite} />
        {t('ViewEditCompany')}
      </DropdownItem>
      <DropdownItem onClick={() => {
        window.open(`/create-user?userEmail=${userEmail}&division=${division}`, '_blank');
      }}
      >
        <DropdownItemIcon iconSrc={EditWhite} />
        {t('EditUser')}
      </DropdownItem>
    </StyledMDBDropdownMenu>
  </MDBDropdown>
);

const initialValues = {
};

class ManageCompanies extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      dataPerPage: 10,
      // eslint-disable-next-line react/no-unused-state
      totalPages: [],
      displayCustomizeTableView: false,
      // eslint-disable-next-line react/no-unused-state
      addCompanyFlag: false,
      selectedDivisions: {
        Truckmate: true,
        Sameday: false,
        Freight: false,
      },
      columns: [
        {
          id: 1,
          label: '',
          field: 'actions',
          sort: false,
          selected: true,
          default: true,
          grow: 0,
        },
        {
          id: 2,
          label: t('Division'),
          field: 'division',
          sort: true,
          selected: true,
          default: true,
          grow: 0,
        },
        {
          id: 3,
          label: t('CompanyName'),
          field: 'companyName',
          sort: true,
          selected: true,
          default: true,
          disabled: true,
          grow: 0,
        },
        {
          id: 4,
          label: t('Description'),
          field: 'description',
          sort: true,
          selected: true,
          default: true,
          grow: 1,
        },
        {
          id: 5,
          label: t('Admin'),
          field: 'isAdmin',
          sort: true,
          selected: true,
          default: true,
          grow: 0,
        },
        {
          id: 6,
          label: t('UserEmailId'),
          field: 'userEmail',
          sort: true,
          selected: true,
          default: true,
          grow: 0,
        },
        {
          id: 7,
          label: t('Status'),
          field: 'status',
          sort: true,
          selected: true,
          default: true,
          grow: 0,
        },
        {
          id: 8,
          label: t('AccountNumbers'),
          field: 'accountNumbers',
          sort: true,
          selected: false,
          default: false,
          grow: 0,
        },
      ],
    };
  }

  getDivisionLabel = (divisionName) => {
    const labels = {
      Truckmate: t('DivisionTruckmate'),
      Sameday: t('DivisionSameday'),
      Freight: t('DivisionFreight'),
    };
    return labels[divisionName] || divisionName;
  };

  convertDataFormat = (data, divisionName) => data.map((each) => ({
    companyId: each.companyId,
    division: this.getDivisionLabel(divisionName),
    companyName: each.companyName,
    description: each.description,
    isAdmin: each.isAdmin ? <CommonIcon iconSrc={CheckmarkCircledOrange} /> : <CommonIcon iconSrc={CloseGray} />,
    userEmail: each.userEmail,
    status: each.isActive ? t('Enabled') : t('Disabled'),
    accountNumbers: each.accountNumber.replace(' ,', ', '),
    actions: <Dropdown
      companyId={each.companyId}
      userEmail={each.userEmail}
      division={divisionName}
    />,
  }));

  getTotalPages = () => {
    const { dataPerPage, data } = this.state;
    const totalPages = [];
    for (let i = 1; i <= Math.ceil(data.length / dataPerPage); i++) {
      totalPages.push(i);
    }

    // eslint-disable-next-line react/no-unused-state
    this.setState({ totalPages });
  };

  handleCreateCompany = (e) => {
    e.preventDefault();
    const createCompanyUrl = `${homeUrlNoTrailingSlash()}${routes.createCompany}`;
    window.open(createCompanyUrl, '_blank');
    localStorage.setItem('addCompanydata', JSON.stringify(this.state.data));
  };

  toggleCustomizeTableView = () => {
    if (runningOnBrowser()) {
      window.scrollTo(0, 0);
    }

    this.setState((prevState) => ({ displayCustomizeTableView: !prevState.displayCustomizeTableView }));
  };

  updateTable = (newColumns) => {
    this.setState({ columns: newColumns });
  };

  handleDivisionCheckboxChange = (divisionKey) => {
    this.setState((prevState) => ({
      selectedDivisions: {
        ...prevState.selectedDivisions,
        [divisionKey]: !prevState.selectedDivisions[divisionKey],
      },
    }));
  };

  handleAllDivisionsChange = (e) => {
    const { checked } = e.target;
    this.setState({
      selectedDivisions: {
        Truckmate: checked,
        Sameday: checked,
        Freight: checked,
      },
    });
  };

  handleSearchCompanies = () => {
    const { formData } = this.props;
    const { selectedDivisions } = this.state;

    const divisionsToSearch = Object.keys(selectedDivisions)
      .filter((key) => selectedDivisions[key]);

    if (divisionsToSearch.length === 0) return;

    const promises = divisionsToSearch.map((division) => {
      const formDatatoAPI = {
        division,
        userEmail: formData.searchByUserEmail ? formData.searchByUserEmail : '',
        accountNumber: formData.searchByAccountNumber ? formData.searchByAccountNumber : '',
        companyName: formData.searchByCompany ? formData.searchByCompany : '',
      };

      return getSearchedCompaniesList(division, formDatatoAPI)
        .then((res) => {
          if (res.status === 200) {
            return this.convertDataFormat(res.data, division);
          }

          return [];
        })
        .catch(() => []);
    });

    Promise.all(promises).then((results) => {
      const allData = results.flat();
      const { putReduxAllCompanies } = this.props;
      putReduxAllCompanies(allData);
      // eslint-disable-next-line react/no-unused-state
      this.setState({ data: allData, addCompanyFlag: allData.length !== 0 }, () => this.getTotalPages());
    });
  };

  render() {
    const { data, columns, selectedDivisions } = this.state;
    const { formData } = this.props;
    const searchByUserEmail = formData && formData.searchByUserEmail ? formData.searchByUserEmail : '';
    const searchByAccountNumber = formData && formData.searchByAccountNumber ? formData.searchByAccountNumber : '';
    const searchByCompany = formData && formData.searchByCompany ? formData.searchByCompany : '';
    const allSelected = selectedDivisions.Truckmate && selectedDivisions.Sameday && selectedDivisions.Freight;
    const {
      rendering: {
        fields: {
          heading,
        },
      }, fields,
    } = this.props;
    return (
      <ManageCompaniesContainer>
        <TitleGroup>
          <H2>{heading.value}</H2>
        </TitleGroup>
        <DivisionCheckboxesContainer>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label>
            <input
              type="checkbox"
              checked={selectedDivisions.Truckmate}
              onChange={() => this.handleDivisionCheckboxChange('Truckmate')}
            />
            {t('DivisionTruckmate')}
          </label>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label>
            <input
              type="checkbox"
              checked={selectedDivisions.Sameday}
              onChange={() => this.handleDivisionCheckboxChange('Sameday')}
            />
            {t('DivisionSameday')}
          </label>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label>
            <input
              type="checkbox"
              checked={selectedDivisions.Freight}
              onChange={() => this.handleDivisionCheckboxChange('Freight')}
            />
            {t('DivisionFreight')}
          </label>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label>
            <input
              type="checkbox"
              checked={allSelected}
              onChange={this.handleAllDivisionsChange}
            />
            {t('AllDivisions')}
          </label>
        </DivisionCheckboxesContainer>
        <FilterContainer>

          <div className="row input-row">
            <div className="col-md-4">
              <Field
                name="searchByUserEmail"
                type="text"
                component={TextInput}
                validate={[anyOneRequiredInGroup]}
                label={fields.searchByUserEmail && fields.searchByUserEmail.value}
              />
            </div>
            <div className="col-md-4">
              <Field
                name="searchByCompany"
                type="text"
                component={TextInput}
                validate={[anyOneRequiredInGroup]}
                label={fields.SearchByAccountNumber && fields.SearchByAccountNumber.value}
              />
            </div>
            <div className="col-md-4">
              <Field
                name="searchByAccountNumber"
                type="text"
                component={TextInput}
                validate={[anyOneRequiredInGroup]}
                label={fields.SearchByCompany && fields.SearchByCompany.value}
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <ButtonGroup>
                <PrimaryButton
                  showArrow={false}
                  onClick={(e) => this.handleCreateCompany(e)}
                >
                  {t('AddCompany')}
                </PrimaryButton>
                <PrimaryButton
                  showArrow={false}
                  disabled={
                    !(searchByUserEmail !== '' || searchByCompany !== '' || searchByAccountNumber !== '')
                    || !(selectedDivisions.Truckmate || selectedDivisions.Sameday || selectedDivisions.Freight)
                  }
                  onClick={(e) => this.handleSearchCompanies(e)}
                >
                  {t('Search')}
                </PrimaryButton>
              </ButtonGroup>
            </div>
          </div>
        </FilterContainer>
        <NoDataDecorator component={SortableTableStyled} data={data} columns={columns} wrapText />
        {
          this.state.displayCustomizeTableView && (
            <CustomizeTableView
              columns={columns}
              updateTable={this.updateTable}
              hideView={this.toggleCustomizeTableView}
            />
          )
        }
      </ManageCompaniesContainer>
    );
  }
}

const mstp = (state) => ({
  formData: getFormValues(formName)(state),
  userId: state.profile.userId,
  allCompanies: state.user.allCompanies,
});

const mdtp = (dispatch) => ({
  putReduxAllCompanies: (allCompanies) => dispatch(putReduxAllCompanies(allCompanies)),
});

ManageCompanies = reduxForm({
  form: formName, // a unique identifier for this form
  initialValues,
})(ManageCompanies);

export default connect(mstp, mdtp)(ManageCompanies);

Dropdown.propTypes = {
  companyId: PropTypes.number,
  userEmail: PropTypes.string,
  division: PropTypes.string,
};

ManageCompanies.propTypes = {
  formData: PropTypes.object,
  putReduxAllCompanies: PropTypes.func,
  rendering: PropTypes.shape({
    fields: PropTypes.shape({
      heading: PropTypes.object,
      description: PropTypes.object,
      SearchByUserEmail: PropTypes.object,
      SearchByAccountNumber: PropTypes.object,
      SearchByCompany: PropTypes.object,
    }),
  }),
  fields: PropTypes.shape({
    searchByUserEmail: PropTypes.object,
    SearchByAccountNumber: PropTypes.object,
    SearchByCompany: PropTypes.object,
  }),
};

